<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.edit-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('Edit Repairable Defect') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <button class="btn btn-red rounded-none rounded-l-md" type="button" @click="deleteDefectModal = true">
            {{ $t('Delete') }}
          </button>
          <router-link class="btn btn-app rounded-none rounded-r-md" to="/admin/repairable-defects">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="updateDefect">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Defect information') }}
              </h3>
              <p class="form-description-text">{{ $t('Defect information and customization') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-3">
                <div class="col-span-3">
                  <label class="form-label" for="device_id">{{ $t('Device') }}</label>
                  <div class="pt-1">
                    <select class="form-input bg-white" id="device_id" required v-model="defect.device_id">
                      <option :value="null" disabled>
                        {{ $t('Select an option') }}
                      </option>
                      <option :key="index" :value="device.id" v-for="(device, index) in deviceList">
                        {{ device.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="title">{{ $t('Defect Title') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Defect Title')" class="form-input" id="title" required v-model="defect.title" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="time">{{ $t('Repair required time') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Repair required time')" class="form-input" id="time" required v-model="defect.required_time" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="cost">{{ $t('Cost') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Cost')" class="form-input" id="cost" required v-model="defect.cost" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="price">{{ $t('Price') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Price')" class="form-input" id="price" required v-model="defect.price" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <span class="inline-flex">
              <router-link class="btn btn-secondary shadow-sm rounded-md mr-4" to="/admin/repairable-defects">{{
                $t('Cancel')
              }}</router-link>
              <button class="btn btn-app shadow-sm rounded-md" type="submit">
                {{ $t('Update') }}
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
    <defect-delete-model :show="deleteDefectModal" @cancelled="deleteDefectModal = false" @confirmed="deleteDefect">
      <template #title>{{ $t('Defect delete') }}</template>
      {{ $t('Are you sure you want to delete the defect?') }}
      {{ $t('All data will be permanently removed') }}.
    </defect-delete-model>
  </main>
</template>
<script>
import confirmationModel from '@/components/layout/admin/confirmation';

export default {
  name: 'edit',
  metaInfo() {
    return {
      title: this.$i18n.t('Edit defect'),
    };
  },
  components: {
    DefectDeleteModel: confirmationModel,
  },
  data() {
    return {
      loading: true,
      deleteDefectModal: false,
      deviceList: [],
      defect: {
        name: null,
        price: null,
        cost: null,
        required_time: null,
      },
    };
  },
  mounted() {
    this.getDefect();
  },
  methods: {
    updateDefect() {
      this.loading = true;
      axios
        .put(route('defects.update', this.$route.params.id), this.defect)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getDefect() {
      this.loading = true;
      axios
        .get(route('defects.show', this.$route.params.id))
        .then((response) => {
          this.deviceList = response.data.device_list;
          this.defect = response.data.defect;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteDefect() {
      axios
        .delete(route('defects.destroy', this.$route.params.id))
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push('/admin/repairable-defects');
        })
        .catch(() => {
          this.deleteDefectModal = false;
        });
    },
  },
};
</script>
